
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nido",
      function () {
        return require("private-next-pages/nido/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nido"])
      });
    }
  